// Wartungsstatus für die App-Shell (meterreading/App.vue, landpages/App.vue).
// Ausgewertet einmal beim Laden — Regeln und Config-Format in maintenance.ts.
//
// Steht die Meldung mit einem Ende, lädt die Seite kurz nach diesem Ende neu
// und zeigt dann wieder die Anwendung (bzw. eine verlängerte Meldung, falls
// end in cos-config.json inzwischen verschoben wurde).

import { resolveConfig } from "./ene";
import {
  isMaintenanceBypassed,
  resolveMaintenance,
  type MaintenanceState,
} from "./maintenance";

// setTimeout läuft bei Werten > 2^31-1 ms (~24,8 Tage) sofort über. Ein
// früherer Reload ist harmlos: er wertet neu aus und plant erneut.
const MAX_TIMEOUT_MS = 2_147_483_647;
const RELOAD_GRACE_MS = 5_000;

let reloadTimer: ReturnType<typeof setTimeout> | undefined;

export function useMaintenance(now: Date = new Date()): MaintenanceState {
  const cfg = resolveConfig().maintenance;
  const state = resolveMaintenance(cfg, now, isMaintenanceBypassed(cfg));

  if (state.active) {
    console.info("[ene] Wartungsmeldung aktiv", state.end ? `bis ${state.end.toISOString()}` : "(ohne Ende)");
    if (state.end && reloadTimer === undefined && typeof window !== "undefined") {
      const delay = Math.min(state.end.getTime() - now.getTime() + RELOAD_GRACE_MS, MAX_TIMEOUT_MS);
      reloadTimer = setTimeout(() => window.location.reload(), Math.max(delay, 0));
    }
  }
  return state;
}
